<div>Search Space</div>

<div class="max-height">
  <app-locker-search-list></app-locker-search-list>
</div>
